export default "__VITE_PUBLIC_ASSET__dd66c5bc__"